import { useEffect, useState } from "react";

const breakpoints = {
  "2xl": 1536,
  "3xs": 320,
  "2xs": 416,
  xs: 512,
  sm: 640, // mobile
  md: 768, // tablet
  lg: 1024, // desktop
  xl: 1280,
} as const;

export function useBreakpoint(): keyof typeof breakpoints | "base" {
  const getBreakpoint = () => {
    const width = window.innerWidth;

    if (width >= breakpoints["2xl"]) return "2xl";
    if (width >= breakpoints.xl) return "xl";
    if (width >= breakpoints.lg) return "lg";
    if (width >= breakpoints.md) return "md";
    if (width >= breakpoints.sm) return "sm";
    if (width >= breakpoints.xs) return "xs";
    if (width >= breakpoints["2xs"]) return "2xs";
    if (width >= breakpoints["3xs"]) return "3xs";
    return "base";
  };

  const [bp, setBp] = useState<keyof typeof breakpoints | "base">(
    typeof window === "undefined" ? "base" : getBreakpoint()
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handler = () => setBp(getBreakpoint());

    window.addEventListener("resize", handler);
    handler(); // initial update

    return () => window.removeEventListener("resize", handler);
  }, []);

  return bp;
}
